import axios from 'axios'
import store from '@/store'
import router from "@/router";
import {toast} from "../class/Notification";
import {findObjectIndex} from "../class/Converter";
import {queryBuilder, filters} from '../class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))



export default {
    namespaced: true,
    state: {
        ...filtersCopy,
    },
    mutations: {
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        getLogs({commit, state}, page = 1) {
            const query = queryBuilder(state.filters)
            let req = axios.get(`/logs?page=${page}&${query}`)
            req.then(res => {
                const data = res.data.data;

            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
    },
    getters: {
        getFilters: (state) => state.filters,
    }
}